import React from 'react';
import { EventTask, useProjectTasksService, } from 'nekst-api';
import { Button, ButtonColor, ButtonSize, isReactNative, useFormContextRequired, usePopupManager, } from 'ui-builder';

import { EventPreview } from './EventPreview';
import { ClosePopupButton, Popup } from 'features/nekst-widgets';

function PreviewFromPopup(
  props: {
    task: EventTask;
    onSaved?: () => void;
  }
) {
  const task = props.task;
  const popupManager = usePopupManager();
  const projectTasksService = useProjectTasksService();

  return (
    <Popup
      title="Preview Appointment"
      content={<EventPreview task={task} />}
      isBig={isReactNative()}
      buttons={(
        <>
          <Button
            text="Save Appointment"
            color={ButtonColor.GREEN}
            onClick={async () => {
              if (task.id) {
                await projectTasksService.updateTask(task.id, task);
              } else {
                await projectTasksService.createEventTask(task.projectId, task);
              }
              props.onSaved?.();
              popupManager.closePopup(true);
            }}
            size={ButtonSize.MEDIUM}
          />
          <ClosePopupButton
            text="Go Back"
            color={ButtonColor.GRAY}
            size={ButtonSize.MEDIUM}
          />
        </>
      )}
    />
  );
}


export function PreviewAndUpdateEventButton() {
  const popupManager = usePopupManager();
  const formContext = useFormContextRequired<EventTask>();

  const data = formContext.data as EventTask;

  const openForm = async () => {
    if (await formContext.validate()) {

      popupManager.openPopup(
        <PreviewFromPopup
          task={data}
        />,
        true
      );
    }
  }

  return (
    <Button
      onClick={async () => {
        await openForm();
      }}
      text="Preview & Save"
      size={ButtonSize.BIG}
      color={ButtonColor.GREEN}
    />
  )
}
